import * as z from "zod/v4";

export const enableDisputesBilling = {
  name: "enableDisputesBilling" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
